import React, { useContext, useState, useEffect } from 'react';
import { IAppContext, AppContext } from 'appState/appContext';
import { IGetSubcategoryInfoV2 } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import { getSubcategoryInfoV2, updateRestaurantsInSubcategory } from 'backend/subcategories';
import { ModalContent } from 'components/ModalWindows/ModalContent';
import FullInfoField from 'components/FullInfoField/FullInfoField';
import Text from 'components/Text/Text';
import { RestaurantMultipleSelect } from './RestaurantMultipleSelect';

interface IProps {
	onCloseModal: () => void;
	onFailureEvent?: () => void;
	onShowError: () => void;
	subcategoryId: string;
}

export const ModalAssignSubcategoryToRestaurants: React.FC<IProps> = ({
	onCloseModal,
	onFailureEvent,
	onShowError,
	subcategoryId,
}) => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const [selectedRestaurants, setSelectedRestaurants] = useState<string[]>([]);
	const { response, loading } = useFetchData<IGetSubcategoryInfoV2, string>(getSubcategoryInfoV2, subcategoryId);

	useEffect(() => {
		loading ? showLoader() : hideLoader();
	}, [loading]);

	useEffect(() => {
		if (response) {
			setSelectedRestaurants(response.data.restaurants.map((restaurant) => restaurant.id));
		}
	}, [response]);

	const handleAssignRestaurants = async () => {
		try {
			showLoader();
			await updateRestaurantsInSubcategory({
				subcategoryId,
				restaurantIds: selectedRestaurants,
			});
			onCloseModal();
		} catch (err) {
			onShowError();
		} finally {
			hideLoader();
		}
	};

	return (
		<ModalContent
			onConsentEvent={handleAssignRestaurants}
			onFailureEvent={onFailureEvent ? onFailureEvent : onCloseModal}
			heading="attachedRestaurants"
			headerTranslationNameSpace="listing"
			translationOfConfirmBtn="saveButton"
			headingAlignment="left"
			centered={false}>
			<FullInfoField label="customerLabel" />
			<Text translationKey={response?.data.customer.name} size="s" />
			<RestaurantMultipleSelect
				setSelectedRestaurants={setSelectedRestaurants}
				selectedRestaurants={selectedRestaurants}
				categoryId={response?.data.category.id}
			/>
		</ModalContent>
	);
};
